import { Form, showAlert } from '@beehive/components';
import React, { useEffect, useRef, useState, } from 'react';
import Bottom from './Bottom';
import { getDetailFileList, getFormItemList } from './utils';
import _ from 'lodash';
import { TabContent } from 'containers/SmWorkbench/ProjectDetail/Show/Detail/Bottom/components';
import PureFormItem from 'components/PureFormItem';
import './index.less';
import NewCooperate from "@mpc/common/src/features/NewCooperate";
import StatementAttachment from '@mpc/common/src/features/StatementAttachment';
import StatementAttachmentItem from '@mpc/common/src/features/StatementAttachmentItem';
import { useMemoizedFn } from "ahooks";
import UploaderMarketingWorks from "containers/OutWorkbench/components/UploaderMarketingWorks";
import UploadHeatingBoostWorks from 'containers/OutWorkbench/components/UploadHeatingBoostWorks';

export const XiaoHao = (props: any) => {
  const {
    detail,
    tabKey,
    projectMove,
    loadDetail,
    menuKey = 'making',
    handleSubmitBody,
  } = props;
  const [formData, setFormData] = useState<any>({
    final_settle_price: '',
    settle_report_attachs_blob_ids: [],
    upload_work: 0,
    boost: 0,
  });
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState(false);

  const [statementAttachment, setStatementAttachment] = useState({})
  const [cooperateData, setCooperateData] = useState<any>(null);
  const cooperateRef = useRef<any>(null);
  const formRef = useRef<any>(null);
  const statementAttachmentRef = useRef<any>(null);
  const attachmentRef = useRef<any>(null);

  const handleChange = ({ formItemKey, value }: any) => {
    const newFormData = _.cloneDeep(formData);
    newFormData[formItemKey] = value;
    setFormData(newFormData);
  };

  useEffect(() => {
    setFormData({
      final_settle_price: '',
      settle_report_attachs_blob_ids: getDetailFileList(detail),
      upload_work: 0,
      boost: detail?.boost_effect_data_count
    });
    setStatementAttachment({
      signed_statement_attachs: detail?.signed_statement_attachs
    })
  }, [detail]);

  const handleSubmit = useMemoizedFn(
    async (key: string, value: any) => {
      if (cooperateRef?.current?.valid() === false) {
        return;
      }

      if (!formRef.current.valid()) {
        setFormError(true);
        return;
      }
      await statementAttachmentRef?.current?.validateFields?.()
      const signed_statement_attachs_blob_keys = statementAttachment?.signed_statement_attachs?.map?.((item: any) => item?.blob?.key) || [];
      const statementAttachmentValue = {
        ...statementAttachment,
        signed_statement_attachs: undefined,
      }
      let submitBody: any = {
        id: detail.id,
        making: {
          demand_advertising_attributes: {
            id: detail.demand_advertising.id,
            final_settle_price: formData['final_settle_price'],
            // 报价金额币种未入库，需要 前端传递 回后端
            final_settle_currency: detail.demand_advertising.dspf_offer_currency,
          },
          invoice_upload_dto: statementAttachmentValue, // 发票附件
          signed_statement_attachs_blob_keys, // 结算单附件
          settle_report_attachs_blob_ids:
            formData['settle_report_attachs_blob_ids'],
          is_pass: true,
          ...(cooperateData || {}),
        },
      };

      if (handleSubmitBody) {
        submitBody = handleSubmitBody(submitBody);
      }

      setLoading(true);
      return projectMove(submitBody, { menuKey })
        .then((res: any) => {
          showAlert({ type: 'success', message: res.res_msg });
          loadDetail();
        })
        .finally(() => {
          setLoading(false);
        });
    }
  );


  const onDataChange = useMemoizedFn((data) => {
    setFormData({
      ...formData,
      upload_work: data.num,
      attach_flag: data.attach_flag
    })
  })

  const formItemList = getFormItemList(detail, handleChange, formData);
  const prefix = `mpc-detail-bottom-bind-execute-data`;
  const requiredKeys = formItemList
    .filter((v) => v.required)
    .map((i: any) => i.key);

  return (
    <TabContent
      tabKey={tabKey}
      bottom={
        <Bottom
          loading={loading}
          onSubmit={handleSubmit}
          formData={formData}
          requiredKeys={requiredKeys}
        />
      }
      canScroll={true}
      className={`${prefix}`}
    >

      {!!detail?.structured && <NewCooperate
        ref={cooperateRef}
        showBindDataKpi={false}
        hasTitle={false}
        view={false}
        detail={detail}
        planInfo={cooperateData || detail.project_plan_info}
        category_id={detail.l3_category_id}
        onChange={(planInfo: any) => {
          setCooperateData(planInfo);
        }}
      />}
      <Form
        ref={formRef}
        isLabelVertical={false}
        mode="edit"
        itemColProps={{ span: 24 }}
        itemLabelColProps={{ span: 8 }}
        itemInputColProps={{ span: 16 }}
        showError={formError}
        style={{ minHeight: 100 }}
      >
        {formItemList.map((formItem) => {
          const { childProps, ...reset } = formItem;
          if (formItem.key === 'upload_work') {
            return <Form.Item {...reset} key={reset.key}>
              <UploaderMarketingWorks
                detail={detail}
                onDataChange={onDataChange}
              />
            </Form.Item>
          }

          if (formItem.key === 'boost') {
            return <Form.Item {...reset} key={reset.key}>
              <UploadHeatingBoostWorks
                detail={detail}
                initBoostNum={detail?.boost_effect_data_count}
                onChange={(data) => {
                  handleChange({
                    formItemKey: 'boost',
                    value: data
                  })
                }}
              />
            </Form.Item>
          }

          if (formItem?.childProps?.type === 'attachment') {
            return (
              <Form.Item {...reset} key={reset.key}>
                <StatementAttachment handleDownLoad={(value) => {
                  setFormData({
                    ...formData,
                    signed_statement_attachs: value,
                  })
                }} ref={attachmentRef} style={{ marginTop: '5px' }} detail={detail} />
              </Form.Item>
            )
          }

          return (
            <Form.Item {...reset} key={reset.key}>
              <PureFormItem {...childProps} formItemKey={reset.key} />
            </Form.Item>
          );
        })}
      </Form>

      {
        (detail?.product_area === 'OVERSEAS') && <div className='making-statement-attachment'>
          <StatementAttachmentItem
            ref={statementAttachmentRef}
            value={statementAttachment}
            onChange={setStatementAttachment}
            detail={detail}
          />
        </div>
      }
    </TabContent>
  );
};
